import moment from 'moment';

import FLAG from 'config/flag.singleton';
import logger from 'utils/logger.util';
import equalShallow from 'utils/objects/equalShallow.util';

const L = logger('shouldUpdateWeekColumn'); // eslint-disable-line no-unused-vars

const shouldUpdateWeekColumn = (options) => {
  if (FLAG.updateColumnsAlways) return true;

  const prev = options?.prev ?? {};
  const next = options?.next ?? {};

  if (prev.isDragDisabledByFetch !== next.isDragDisabledByFetch) return true;
  if (prev.isProcedureModalMounted !== next.isProcedureModalMounted) return true;
  if (prev.panel !== next.panel) return true;

  const state = options?.state ?? {};
  const keys = Object.keys(next);

  for (const key of keys) {
    const areDifferent = !equalShallow(next[key], prev[key]);

    if ('dayWholeDate' !== key && 'addedServices' !== key && 'bookingTime' !== key && areDifferent) return true;

    const first = state?.currentRangeByHours?.[0];
    const last = state?.currentRangeByHours?.[state?.currentRangeByHours?.length - 1];

    if (key === 'addedServices') {
      for (let i = 0; i < next?.addedServices?.length; i += 1) {
        const startNg = moment(next?.addedServices?.[i]?.start_time);
        if (startNg.isSameOrAfter(first) && startNg.isSameOrBefore(last)) return areDifferent;
      }
      for (let j = 0; j < prev?.addedServices?.length; j += 1) {
        const startOg = moment(prev?.addedServices?.[j]?.start_time);
        if (startOg.isSameOrAfter(first) && startOg.isSameOrBefore(last)) return areDifferent;
      }
    }

    if ('bookingTime' === key) {
      const nextBookingTimeAsMoment = moment(next.bookingTime);
      if (
        next.bookingTime &&
        nextBookingTimeAsMoment.isSameOrAfter(first) &&
        nextBookingTimeAsMoment.isSameOrBefore(last)
      ) {
        if (areDifferent) return true;
      } else {
        const prevBookingTimeAsMoment = moment(prev.bookingTime);
        if (
          prev.bookingTime &&
          prevBookingTimeAsMoment.isSameOrAfter(first) &&
          prevBookingTimeAsMoment.isSameOrBefore(last) &&
          areDifferent
        ) {
          return true;
        }
      }
    }
  }

  if (FLAG.updateColumnsLogNegatives) L.debug('()', false, '<-', options);

  return false;
};

export default shouldUpdateWeekColumn;
